import React from "react";

const BookLoading = () => {
    return (
        <div style={styles.container}>
            <img
                src="/Bookgif.gif" // Or use an external URL if not hosted locally
                alt="Loading..."
                style={styles.gif}
            />
        </div>
    );
};

const styles = {
    container: {
        height: "100vh",
        width: "100vw",
        backgroundColor: "#fff", // or #f5f5f5 for soft background
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        position: "fixed",
        top: 0,
        left: 0,
    },
    gif: {
        width: "150px",
        height: "150px",
        objectFit: "contain",
    },
};

export default BookLoading;
